import React, { useEffect, useRef } from 'react';
import newBanner from '../assets/images/offer-popups/new-banner.webp';

function OfferPopup() {
  const modalRef = useRef(null);

  useEffect(() => {
    // Check sessionStorage — if popup was already shown this session, skip it
    const alreadyShown = sessionStorage.getItem('offerPopupShown');
    if (alreadyShown) return;

    const timer = setTimeout(() => {
      if (modalRef.current && window.bootstrap) {
        const modal = new window.bootstrap.Modal(modalRef.current);
        modal.show();
        // Mark as shown for the rest of this browser session
        sessionStorage.setItem('offerPopupShown', 'true');
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="modal fade" id="azadiModal" tabIndex="-1" aria-labelledby="popupLabel" aria-hidden="true" ref={modalRef}>
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content border-0 bg-transparent p-0 position-relative">
          <button
            type="button"
            className="btn-close position-absolute top-0 end-0 m-2 bg-white rounded-circle"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <img loading="lazy" src={newBanner} alt="Special Offer" className="img-fluid rounded w-100" />
        </div>
      </div>
    </div>
  );
}

export default OfferPopup;